import axios from 'axios';

let apiEndpoint = process.env.VUE_APP_API_BASEURL

export default {
    async generateAuthenticationRequest(email) {
        return await axios.post(`${apiEndpoint}/dashboard/auth`, { email: email }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
    async verifyAuthenticationToken(token) {
        return axios.get(`${apiEndpoint}/dashboard/auth?token=` + token, {
            withCredentials: true
        })
    },
    getLatestActivity() {
        return axios.get(`${apiEndpoint}/dashboard/activity`, {
            withCredentials: true
        })
    },
    getStats() {
        return axios.get(`${apiEndpoint}/dashboard/stats`, {
            withCredentials: true
        })
    },
    getCompanies() {
        return axios.get(`${apiEndpoint}/dashboard/companies`, {
            withCredentials: true
        })
    },
    updateCompany(companyId, data) {
        return axios.patch(`${apiEndpoint}/dashboard/companies/${companyId}`, data, {
            withCredentials: true
        })
    },
    checkCompanyNameConflicts(data) {
        return axios.post(`${apiEndpoint}/dashboard/companies/name-conflicts`, data, {
            withCredentials: true
        })
    },
    getJob(jobUUID) {
        return axios.get(`${apiEndpoint}/dashboard/job/` + jobUUID, {
            withCredentials: true
        })
    },
    getJobs(companyId) {
        const url = companyId ? `${apiEndpoint}/dashboard/jobs/${companyId}` : `${apiEndpoint}/dashboard/jobs`;
        return axios.get(url, {
            withCredentials: true
        });
    },
    getContractors() {
        return axios.get(`${apiEndpoint}/dashboard/contractors`, {
            withCredentials: true
        })
    },
    getContractor(contractorId) {
        return axios.get(`${apiEndpoint}/dashboard/contractors/` + contractorId, {
            withCredentials: true
        })
    },
    async getContractorResume(contractorId) {
        return axios.get(`${apiEndpoint}/dashboard/contractors/` + contractorId + '/resume', {
            withCredentials: true,
            responseType: 'blob'
        })
    },
    async getHiddenProfile(contractorId) {
        return axios.post(`${apiEndpoint}/dashboard/contractors/export-hidden-profile`, {
            ids: [contractorId]
        }, {
            withCredentials: true,
            responseType: 'blob'
        })
    },
    async bulkExportHiddenProfiles(contractorIds) {
        return axios.post(`${apiEndpoint}/dashboard/contractors/export-hidden-profile`, {
            ids: contractorIds
        }, {
            withCredentials: true,
            responseType: 'blob'
        })
    },
    getChart(size) {
        return axios.get(`${apiEndpoint}/dashboard/chart/` + size, {
            withCredentials: true
        })
    },
    addCompanyCredits(data) {
        return axios.post(`${apiEndpoint}/dashboard/credits/add`, data, {
            withCredentials: true
        })
    },
    getCvMatcherUploads() {
        return axios.get(`${apiEndpoint}/dashboard/cv-matcher/uploads`, {
            withCredentials: true
        })
    },
    getCvMatcherUpload(id) {
        return axios.get(`${apiEndpoint}/dashboard/cv-matcher/uploads/${id}`, {
            withCredentials: true
        })
    },
    uploadCvMatcherResume(formData) {
        return axios.post(`${apiEndpoint}/dashboard/cv-matcher/uploads`, formData, {
            withCredentials: true,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    retryCvMatcherUpload(id) {
        return axios.post(`${apiEndpoint}/dashboard/cv-matcher/uploads/${id}/retry`, {}, {
            withCredentials: true
        })
    },
    regenerateCvMatcherResults(id) {
        return axios.post(`${apiEndpoint}/dashboard/cv-matcher/uploads/${id}/regenerate`, {}, {
            withCredentials: true
        })
    },
    downloadCvMatcherResume(id) {
        return axios.get(`${apiEndpoint}/dashboard/cv-matcher/uploads/${id}/resume`, {
            withCredentials: true,
            responseType: 'blob'
        })
    },
    downloadCvMatcherParsedResume(id) {
        return axios.get(`${apiEndpoint}/dashboard/cv-matcher/uploads/${id}/parsed`, {
            withCredentials: true,
            responseType: 'blob'
        })
    }
}
